import { Button, Form, Input, Select, message, Alert } from 'antd';
import { useState } from 'react';
import { InvitationAPIs } from '~/common/typescript/apis/InvitationAPIs';
import { InvitationType } from '~/common/typescript/models/Invitation';
import { useParams } from 'react-router-dom';
import { AC_Organization_Role } from '~/common/typescript/services/access_control/AC_Organization';

const { Option } = Select;

interface FormInviteMemberProps {
  callbackSuccess: () => void;
}

const FormInviteMember = ({ callbackSuccess }: FormInviteMemberProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const params = useParams();

  const onFinish = async (values: { phone_number: string; role: AC_Organization_Role }) => {
    if (!params.organizationID) return;

    setLoading(true);
    try {
      await InvitationAPIs.remote_sendInvitation({
        identifier: values.phone_number,
        organizationId: Number(params.organizationID),
        role: values.role,
        type: InvitationType.ORGANIZATION
      });

      message.success('Lời mời đã được gửi thành công!');
      form.resetFields();
      callbackSuccess();
    } catch (error: any) {
      message.error(error.message || 'Có lỗi xảy ra khi gửi lời mời');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
      <Form.Item
        label="Số điện thoại"
        name="phone_number"
        rules={[
          { required: true, message: 'Vui lòng nhập số điện thoại' },
          // { type: 'email', message: 'Email không hợp lệ' },
        ]}
      >
        <Input placeholder="Nhập SĐT đã đăng ký geocollect" />
      </Form.Item>

      <Form.Item
        label="Vai trò"
        name="role"
        initialValue={AC_Organization_Role.ORGANIZATION_MEMBER}
        rules={[{ required: true, message: 'Vui lòng chọn vai trò' }]}
      >
        <Select placeholder="Chọn vai trò">
          <Option value={AC_Organization_Role.ORGANIZATION_ADMIN}>Quản trị viên</Option>
          <Option value={AC_Organization_Role.ORGANIZATION_EDITOR}>Biên tập viên</Option>
          <Option value={AC_Organization_Role.ORGANIZATION_MEMBER}>Thành viên</Option>
        </Select>
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gửi lời mời
        </Button>
      </Form.Item>
      </Form>
    </div>
  );
};

export default FormInviteMember;